/**
 * Function de validation des commandes
 * @param  {object} values values du formulaire
 */
const validate = (values, props) => {
  const errors = {};
  const itemsArrayErrors = [];
  if (values.items) {
    values.items.forEach((item, itemIndex) => {
      const itemErrors = { customsDeclaration: {} };
      if (!item || !item.externalReference) {
        itemErrors.externalReference = 'Champs requis';
      }
      if ((!item || !item.ean13) && props.isStockHandled) {
        itemErrors.ean13 = 'Champs requis';
      }
      if (item.ean13 && props.isStockHandled) {
        if (
          !props.productBarcode.filter(
            barcode => barcode.barcodeValue === item.ean13
          ).length > 0
        ) {
          itemErrors.ean13 = 'Code-barres inconnu';
        }
      }
      if (item.customsDeclaration) {
        if (!item.customsDeclaration.currency) {
          itemErrors.customsDeclaration.currency = 'Champs requis';
        }
        if (!item.customsDeclaration.declaredValue) {
          itemErrors.customsDeclaration.declaredValue = 'Champs requis';
        }
        if (item.customsDeclaration.declaredValue) {
          if (Number.isNaN(+item.customsDeclaration.declaredValue)) {
            itemErrors.declaredValue =
              'Valeur incorrect ( exemple de valeur correcte : 42.99 )';
          }
        }
        if (!item.customsDeclaration.objectType) {
          itemErrors.customsDeclaration.objectType = 'Champs requis';
        }
      }

      if (!item || !item.quantity) {
        itemErrors.quantity = 'Champs requis';
      }

      itemsArrayErrors[itemIndex] = itemErrors;
    });
  }

  errors.items = itemsArrayErrors;
  return errors;
};

export default validate;
